"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGet = useGet;
var _reactQuery = require("react-query");
var _dist = require("../../dist");
const getData = async (url, pk, token) => {
  const fullUrl = pk ? "".concat(url, "/").concat(pk) : url; // Se `pk` for fornecido, adiciona ao final da URL
  return await (0, _dist.fetchData)(fullUrl, 'GET', token).then(response => response.data);
};

/**
 * Custom React hook that performs a flexible GET request using React Query.
 * This hook can fetch specific resources, a list of resources, or a table depending on the provided URL and optional `pk`.
 *
 * @param {string} url - The base API URL to fetch data from.
 * @param {string | number} [pk] - Optional pk to append to the URL for fetching a specific resource.
 * @param {string} token - The authentication token passed in the request headers.
 * @param {object} [options={}] - Optional configuration object to control the query behavior.
 * @param {boolean} [options.enabled=true] - Whether to enable the query. The query runs only when `enabled` is true.
 * 
 * @returns {object} - Returns the React Query result object, including properties like `data`, `isLoading`, `isError`, `refetch`, etc.
 * 
 * @example
 * // Fetch specific resource using pk
 * const { data, isLoading, isError } = useGet('/user', 1, token);
 * 
 * // Fetch all resources
 * const { data, isLoading, isError } = useGet('/user/all', undefined, token);
 * 
 * // Fetch table data directly
 * const { data, isLoading, isError } = useGet('/user/table', undefined, token);
 */
function useGet(url, pk, token) {
  let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  const {
    enabled = true
  } = options;
  const query = (0, _reactQuery.useQuery)({
    queryFn: () => getData(url, pk, token),
    queryKey: pk ? [url, pk] : [url],
    staleTime: 0,
    cacheTime: 0,
    enabled: !!url && enabled
  });
  return query;
}